export const cammelCase = (value) => value ? value
    .split(' ')
    .map(item => item.substring(0, 1).toUpperCase() + item.substring(1).toLowerCase())
    .join(' ') : ''